import React, { createContext, useState, ReactNode } from 'react';
import { Role } from '../types/Role';

interface MyRoleContextType {
  role: Role | undefined;
  setRole: (role: Role) => void;
}

export const MyRoleContext = createContext<MyRoleContextType>({
  role: undefined,
  setRole: () => {
    // default empty function
  },
});

export const AdminProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [role, setRole] = useState(undefined as Role | undefined);

  return <MyRoleContext.Provider value={{ role, setRole }}>{children}</MyRoleContext.Provider>;
};
